export const ALL_LOCALES = ["de", "en", "es", "fr"] as const;

export type Locale = (typeof ALL_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";

/**
 * Get the native display name for a locale using the Intl API.
 * Falls back to the locale code if Intl.DisplayNames is unavailable.
 */
export function getLocaleName(locale: Locale): string {
  try {
    const name =
      new Intl.DisplayNames([locale], { type: "language" }).of(locale) ??
      locale;
    return name[0]?.toLocaleUpperCase(locale) + name.slice(1);
  } catch {
    return locale;
  }
}
